<script setup lang="ts">
//import { useLangsStore } from "~~/base/app/stores/langs"
//"~~/base/app/stores/user"
const LangsStore = useLangsStore()
const UserStore = useUserStore()

// const toast = useToast()
const open = ref(false)
const collapseds = ref(false)

onMounted(async () => {
	// const cookie = useCookie('cookie-consent')
	// if (cookie.value === 'accepted') {
	// 	return
	// }
	// toast.add({
	// 	title: 'We use first-party cookies to enhance your experience on our website.',
	// 	duration: 0,
	// 	close: false,
	// 	actions: [
	// 		{
	// 			label: 'Accept',
	// 			color: 'neutral',
	// 			variant: 'outline',
	// 			onClick: () => {
	// 				cookie.value = 'accepted'
	// 			},
	// 		},
	// 		{
	// 			label: 'Opt out',
	// 			color: 'neutral',
	// 			variant: 'ghost',
	// 		},
	// 	],
	// })
})

onBeforeMount(async () => {
	// if (localStorage.getItem('figma_node_key')) {
	//   FigmaStore.context.figma_node_key = localStorage.getItem('figma_node_key')
	// } else {
	//   localStorage.setItem('figma_node_key', FigmaStore.context.figma_node_key)
	// }
	// if (localStorage.getItem('ids_key')) {
	//   FigmaStore.context.ids_key = localStorage.getItem('ids_key')
	// } else {
	//   localStorage.setItem('ids_key', FigmaStore.context.ids_key)
	// }
	// console.log("onBeforeMount")
	// await getSetQPar(FigmaStore.context, 'state')
	// switch (FigmaStore.context.state) {
	// 	case 'figma_reader_variables':
	// 		await getSetQPar(FigmaStore.context, 'file_key')
	// 		await getSetQPar(FigmaStore.context, 'figma_node_key')
	// 		await getSetQPar(FigmaStore.context, 'ids_key')
	// 		await getSetQPar(FigmaStore.context, 'variable_filter')
	// 		await getSetQPar(FigmaStore.context, 'full_info')
	// 		await getSetQPar(FigmaStore.context, 'depth_level')
	// 		await getSetQPar(FigmaStore.context, 'hide_keys')
	// 		await getSetQPar(FigmaStore.context, 'show_props')
	// 		await getSetQPar(FigmaStore.context, 'variables_filter_preview')
	// 		await getSetQPar(FigmaStore.context, 'variables_filter_list')
	// 		break
	// 	case 'figma_reader_files':
	// 		await getSetQPar(FigmaStore.context, 'file_key')
	// 		break
	// 	case 'figma_reader_preview':
	// 		await getSetQPar(FigmaStore.context, 'file_key')
	// 		await getSetQPar(FigmaStore.context, 'figma_node_key')
	// 		break
	// }
})
</script>

<template>
	<UDashboardGroup>
		<!-- <UDashboardSearch :groups="groups" /> -->

		<UDashboardSidebar
			v-model:open="open"
			resizable
			collapsible
			:min-size="22"
			:default-size="22"
			:max-size="22"
			:collapsed-size="0"
			class="bg-(--ui-bg-elevated)/25"
			:ui="{ footer: 'lg:border-t lg:border-(--ui-border)' }"
		>
			<template #header="{ collapsed }">
				<div class="flex w-full flex-auto justify-between gap-2">
					<div
						v-if="!collapsed"
						class="text-primary-600 ms-2 mt-1 text-xl"
					>
						{{ LangsStore.getLangEntry("main_langs", "dexterial-projects") }}
					</div>
					<UDashboardSidebarCollapse />
				</div>
			</template>

			<template #default="{ collapsed }">
				<SidebarUser :collapsed="collapsed" />
				<SidebarAdmin :collapsed="collapsed" />
				<SidebarDexStore
					v-if="UserStore.user_full && UserStore.user_full.auth && UserStore.user_full?.roles?.app == 'editor'"
					:collapsed="collapsed"
				/>

				<!-- <SidebarDextools
					v-if="
						UserStore.user_full &&
						UserStore.user_full.auth &&
						UserStore.user_full.claims &&
						UserStore.user_full.claims.apps_access['dextools']
					"
					:collapsed="collapsed"
				/>

				<SidebarAccounting
					v-if="
						UserStore.user_full &&
						UserStore.user_full.auth &&
						UserStore.user_full.claims &&
						UserStore.user_full.claims.apps_access['accounting']
					"
					:collapsed="collapsed"
				/> -->
			</template>

			<template #footer="{ collapsed }">
				<SidebarSettings :collapsed="collapsed" />
			</template>
		</UDashboardSidebar>

		<div style="flex: 1; overflow-y: auto; height: 100vh">
			<slot />
		</div>
		<!-- <SidebarNotifications /> -->
	</UDashboardGroup>
</template>
